/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Frost_Free_Could_Be_Controlled_By_BuildingInputs */



/**
* | output |
* | --- |
* | "Frost-free can be controlled by building" |
*
* @param {Frost_Free_Could_Be_Controlled_By_BuildingInputs} inputs
* @param {{ locale?: "fr" | "en" }} options
* @returns {LocalizedString}
*/
export const frost_free_could_be_controlled_by_building = /** @type {((inputs?: Frost_Free_Could_Be_Controlled_By_BuildingInputs, options?: { locale?: "fr" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Frost_Free_Could_Be_Controlled_By_BuildingInputs, { locale?: "fr" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return /** @type {LocalizedString} */ ("Frost-free can be controlled by building")
	return /** @type {LocalizedString} */ ("Le hors gel peut être contrôlé par bâtiment")
});